import '../../styles/FooterWine.css';
import Code_image from '../../assets/qr-code-blanc.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFacebook,
    faInstagram,
    faYoutube
} from "@fortawesome/free-brands-svg-icons";
import { Condition_vente } from '../../condition_vente';

function footer() {
    
    return (
        <div className="content_wine">
            <div className="top_wine">
                <div className="column_wine">
                    <ul>
                        <li> Chemin des Cyprès 17 </li>
                        <li> 3960 Sierre </li>
                        <a href="/cave/condition/" className='footer_condition'>
                             Mentions légales
                            </a>
                    </ul>
                
                </div>

                <div className="column_wine">
                    <ul>
                        <li> Erwan Tapparel </li>
                        <li> 078 679 67 54 </li>
                        <li> vins@erwantapparel.ch </li>
                   
                    </ul>
                 
                </div>
                <div className="column_wine">
                    <ul>
                        <li className="social_media">
                            <a href="/code-qr/"
                                className="qrcode social">
                                <img src={Code_image} className='qr-code_size' />
                            </a>

                            <a href="https://www.facebook.com/TapparelErwan"
                                className="facebook social" target="_blank">
                                <FontAwesomeIcon icon={faFacebook} size="2x" />
                            </a>
                            <a href="https://www.instagram.com/cavedusonneur"
                                className="insta social" target="_blank">
                                <FontAwesomeIcon icon={faInstagram} size="2x" />
                            </a>          
                        </li>
                   
                      
                        <a href='https://www.webinblocks.ch/' className='footer_link_webinblocks'>&#9400; 2024 - Made with 💡 by WebInBlocks  </a>
                       

                    </ul>
                
                </div>

            </div>

        </div>
    )
}

export default footer